import React from "react";
import { InputRangeRow } from "./index";
import { helpers } from "../../utils";
// Used by Heli KV2008B and Heli KV2019B machines

export default function UpperSpindleSpeedRow({ minProp, maxProp }) {
   const { formatNumberWithThousands } = helpers;
   return (
      <InputRangeRow
         titleProp={"Upper Spindle Speed"}
         descriptionProp={"rpm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={minProp || 1000}
         maxProp={maxProp || 10500}
         propertyNameProp={"speedUpper"}
         errorDialogueProp={minProp ? `${formatNumberWithThousands(minProp)}-${formatNumberWithThousands(maxProp)}` : "1,000-10,500 only"}
         floatProp={false}
      />
   );
}
